import { DecisionPoint } from '../../models/decisionpoint.model';

export class Rules {
   decisionPoints: DecisionPoint[];
}
